import { css } from '@emotion/css';

export const reviewCx = css`
  gap: 0.5rem;
  display: flex;
  padding-bottom: 240px;
  flex-direction: column;

  .actions {
    width: 100%;
    max-width: 550px;
    position: fixed;
    bottom: 0;

    .agreement {
      background-color: white;
      padding: 1rem;
      .field-group {
        margin: 0 1rem;
        &:not(:last-of-type) {
          margin-bottom: 1rem;
        }
      }
    }
  }
`;

export const tncDialog = css`
  top: 0;
  width: 100%;
  z-index: 1000;
  max-width: 550px;
  position: absolute;
  background-color: white;
  padding: 3.5rem 0 5rem 0;

  .header {
    gap: 0.75rem;
    display: flex;
    padding: 1rem;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
  }

  article {
    padding: 1rem;
    padding-bottom: 2rem;
  }

  .actions {
    position: fixed;
    bottom: 0;
    gap: 0.5rem;
    width: 100%;
    display: flex;
    max-width: 550px;
    padding: 1rem 0.75rem;
    background-color: white;
    box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.12);

    .julo-button {
      flex: 1;
    }
  }
`;

export const reviewAccordion = (isOpen: boolean) => css`
  background-color: white;

  .header {
    gap: 1rem;
    display: flex;
    align-items: center;
    padding: 0.75rem 1.5rem;
    justify-content: space-between;
    border: 0px, 0px, 0.5px, 0px;
    border-bottom: 0.5px solid rgba(224, 224, 224, 1);

    .title {
      flex: 1;
      gap: 0.25rem;
      display: flex;
      align-items: center;

      p {
        font-size: 18px;
      }
    }

    .toggle-btn {
      transform: rotate(${isOpen ? '180deg' : '0'});
    }
  }

  .content {
    padding: 0 1rem;
  }
`;
